import React from 'react'
import { Text } from '@vtex/admin-ui'
import type { TextProps } from '@vtex/admin-ui'

export type SalesAssociatesHeaderProps = TextProps

export const SalesAssociatesHeader = ({
  css,
  ...props
}: SalesAssociatesHeaderProps) => (
  <Text variant="title1" css={css}>
    {props.children}
  </Text>
)
